<template>
  <div class="article__container">
    <blog-article v-for="(article, index) in sortedArticles" :key="article.id" :article="article" :featured="index == 0" />
  </div>
</template>

<script>
import BlogArticle from '@/scripts//components/blog/BlogArticle.vue';

export default {
  name: 'BlogWrapper',
  components: { BlogArticle },
  props: {
    articles: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedArticles: function () {
      return this.articles.sort((a, b) => (a.published_at_timestamp < b.published_at_timestamp ? 1 : -1));
    },
  }
};
</script>

<style lang="scss">
</style>